import React, { useEffect, useState } from "react";
import '../../styles/Popup2.css';

import { Link } from "react-router-dom";

const Popup2 = ({
  images = [],
  storageKey = "hidePopupToday",
  autoSlideInterval = 3000, // ms
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [todayChecked, setTodayChecked] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  /* 최초 노출 여부 */
  useEffect(() => {
    const savedDate = localStorage.getItem(storageKey);
    const today = new Date().toISOString().slice(0, 10);

    if (savedDate !== today && images.length > 0) {
      setIsOpen(true);
    }
  }, [storageKey, images]);

  /* 자동 슬라이드 */
  useEffect(() => {
    if (!isOpen || images.length <= 1) return;

    const timer = setInterval(() => {
      setCurrentIndex((prev) =>
        prev === images.length - 1 ? 0 : prev + 1
      );
    }, autoSlideInterval);

    return () => clearInterval(timer);
  }, [isOpen, images.length, autoSlideInterval]);

  /* 닫기 */
  const handleClose = () => {
    if (todayChecked) {
      const today = new Date().toISOString().slice(0, 10);
      localStorage.setItem(storageKey, today);
    }
    setIsOpen(false);
  };

  /* 수동 슬라이드 */
  const prevSlide = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? images.length - 1 : prev - 1
    );
  };

  const nextSlide = () => {
    setCurrentIndex((prev) =>
      prev === images.length - 1 ? 0 : prev + 1
    );
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        {/* 닫기 */}
        <button className="modal-close" onClick={handleClose}>
          ✕
        </button>

        {/* 슬라이드 */}
        <div className="modal-slider">
          {images[currentIndex].link ? (
            <Link
              to={images[currentIndex].link}
              className="slide-link"
            >
              <img
                src={images[currentIndex].url}
                alt="popup"
                className="modal-image"
              />
            </Link>
          ) :
          (
            <img
              src={images[currentIndex].url}
              alt="popup"
              className="modal-image"
            />
          )}         

          {images.length > 1 && (
            <>
              <button className="slide-btn left" onClick={prevSlide}>
                ‹
              </button>
              <button className="slide-btn right" onClick={nextSlide}>
                ›
              </button>
            </>
          )}
        </div>

        {/* 하단 */}
        <div className="modal-footer">
          <label>
            <input
              type="checkbox"
              checked={todayChecked}
              onChange={(e) => setTodayChecked(e.target.checked)}
            />
            오늘은 그만 닫기
          </label>

          {images.length > 1 && (
            <span className="indicator">
              {currentIndex + 1} / {images.length}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default Popup2;